/** Public website. The native app serves its bundle from localhost, so `window.location` cannot say it. */
export const PUBLIC_SITE_ORIGIN = 'https://volleystatspro.com';

export function publicSiteUrl(path: string): string {
  return `${PUBLIC_SITE_ORIGIN}${path.startsWith('/') ? path : `/${path}`}`;
}
